import React, { Suspense } from "react";
//components
import { Box } from "@material-ui/core";
import { FTLJsonLogger, FTLLoader } from "ftl-dashboards-ui-kit";
import { useValidationErrorSnackbar } from "ftl-dashboards-core/dist/hooks/useValidationErrorSnackbar";
import { FTLObjectUtils } from "ftl-dashboards-core/dist/util/object";
export function FTLDetailPage({ formik, children, headerComponent, toolbarComponent, }) {
    useValidationErrorSnackbar({
        condition: formik.isSubmitting && !formik.isValid,
        message: FTLObjectUtils.getFirstPrimitiveValue(formik.errors, "string"),
    });
    return (React.createElement(Box, { mr: 15, ml: 15, display: "flex", flexDirection: "column", style: {
            height: "100%",
        } },
        React.createElement(Box, { marginBottom: "auto" },
            headerComponent,
            React.createElement(FTLJsonLogger, { label: "\u0421\u0442\u0435\u0439\u0442 \u0444\u043E\u0440\u043C\u044B", value: formik.values }),
            React.createElement(FTLJsonLogger, { label: "\u041E\u0448\u0438\u0431\u043A\u0438 \u0444\u043E\u0440\u043C\u044B", value: formik.errors }),
            React.createElement(Suspense, { fallback: React.createElement(FTLLoader, { mt: 30, color: "dark" }) }, children)),
        toolbarComponent));
}
export default FTLDetailPage;
//# sourceMappingURL=index.js.map